var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2585 1.74152C23.0198 0.502826 21.0115 0.502826 19.7728 1.74152L18.3746 3.13974L22.8603 7.62545L24.2585 6.22723C25.4972 4.98854 25.4972 2.98022 24.2585 1.74152Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5786 8.90708L17.0929 4.42137L6.9419 14.5724C6.19661 15.3177 5.64877 16.2369 5.34787 17.247L4.38147 20.4913C4.28647 20.8102 4.37389 21.1555 4.60919 21.3908C4.84449 21.6261 5.18981 21.7135 5.50873 21.6185L8.75297 20.6521C9.7631 20.3512 10.6823 19.8034 11.4276 19.0581L21.5786 8.90708Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34375 5.34374C2.34172 5.34374 0.71875 6.96671 0.71875 8.96874V21.6562C0.71875 23.6583 2.34172 25.2812 4.34375 25.2812H17.0312C19.0333 25.2812 20.6562 23.6583 20.6562 21.6562V15.3125C20.6562 14.812 20.2505 14.4062 19.75 14.4062C19.2495 14.4062 18.8438 14.812 18.8438 15.3125V21.6562C18.8438 22.6573 18.0323 23.4687 17.0312 23.4687H4.34375C3.34273 23.4687 2.53125 22.6573 2.53125 21.6562V8.96874C2.53125 7.96772 3.34273 7.15624 4.34375 7.15624H10.6875C11.188 7.15624 11.5938 6.7505 11.5938 6.24999C11.5938 5.74948 11.188 5.34374 10.6875 5.34374H4.34375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.97b42ef5e17b8925a06fa5d829f82285.svg";
export { ForwardRef as ReactComponent };